import { Typography } from '@mui/material';
import type { FunctionComponent } from 'react';
import { formatElapsed } from '../../helpers/time.helper';
import { useNow } from '../../hooks/use-now.hooks';

export const DownloadTimer: FunctionComponent<{
  startTimestamp: number;
}> = ({ startTimestamp }) => {
  const now = useNow(3000);

  return (
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary'
      }}
    >
      Started {formatElapsed(new Date(startTimestamp), now)} ago
    </Typography>
  );
};
